import { render, staticRenderFns } from "./thirdModal.vue?vue&type=template&id=05d1ff87&scoped=true&"
import script from "./thirdModal.vue?vue&type=script&lang=js&"
export * from "./thirdModal.vue?vue&type=script&lang=js&"
import style0 from "./thirdModal.vue?vue&type=style&index=0&id=05d1ff87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d1ff87",
  null
  
)

export default component.exports